module.exports = __webpack_public_path__ + "static/home-4-m-5a6a075e01615dcc14d8e799503a2b61.mp4";